module.exports = __webpack_public_path__ + "page-heading-pattern.8fc8b6e1c7071061ceb0.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/page-heading-pattern.png
// module id = ../../../../../src/assets/images/page-heading-pattern.png
// module chunks = styles